<div class="d-flex flex-column h-100">
  <div mat-dialog-title>
    <button mat-flat-button class="button--square mat-secondary" [mat-dialog-close]="false">
      <mat-icon svgIcon="arrow-left"></mat-icon>
    </button>

    <div data-testId="select-client-title" i18n="@@shared.clientPickerDialog.lblSelectClient" class="h4 mb-0 ml-2">
      Select Client
    </div>
  </div>

  <mat-dialog-content>
    <mat-selection-list [(ngModel)]="selectedClientId" [multiple]="false" [hideSingleSelectionIndicator]="true">
      <mat-list-option
        class="selectionItem"
        *ngFor="let client of data.clients  | sort : 'name' : 'asc' : false; trackBy: trackClient"
        [value]="client.id"
        [selected]="client.id === selectedClientId[0]"
        [ngClass]="{'selectedMenuItem' : (client.id === selectedClientId[0])}"
      >
        <div class="clientDisplay text-truncate">
          <span
            [title]="client.name"
            [ngClass]="{'font-weight-bold' : (client.id === initialSelection)}"
            class="text-truncate"
          >
            {{ client.name }}
          </span>
          <span
            class="text-small text-muted"
            *ngIf="client.id === initialSelection"
            i18n="@@shared.clientPickerDialog.txtActiveSession"
          >
            Active session
          </span>
        </div>

        <ng-container *ngIf="client?.logoUrl; else logoPlaceholder">
          <img class="accountPicker_logo ml-auto pl-1" [src]="client?.logoUrl" [alt]="client.name" />
        </ng-container>
        <ng-template #logoPlaceholder>
          <span class="ml-auto">&nbsp;</span>
        </ng-template>
      </mat-list-option>
    </mat-selection-list>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="save()">
      <mat-icon svgIcon="check"></mat-icon>
      {{StaticMessage.DoneButton | staticMessage}}
    </button>
    <button mat-button color="primary" [mat-dialog-close]="false">
      {{StaticMessage.CancelButton | staticMessage}}
    </button>
  </mat-dialog-actions>
</div>
